import React from "react";
import { IoPrintOutline } from "react-icons/io5";
import ExportMenu from "../menu";
import { ClientReport, ReferralRecord, MedicalRecord } from "./components";

interface PrintProps {
  caseId: number;
  handleClose(): void;
}

const Print: React.FC<PrintProps> = props => {
  return (
    <ExportMenu
      buttonName="Create PDF"
      buttonIcon={IoPrintOutline}
      menuList={
        <>
          <MedicalRecord {...props} />
          <ClientReport {...props} />
          <ReferralRecord {...props} />
        </>
      }
    />
  );
};

export default Print;
